<syn-message-box leftIcon="information-outline"
                  color="info"
                  class="info-box"
                  *ngIf="!hasProjects()">
    Cette société n'est associée à aucun projet
</syn-message-box>

<div *ngIf="hasProjects()">
  <form [formGroup]="dataForm">
    <div class="table-actions" fxLayout="row" fxLayoutAlign="space-between center" >
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-checkbox color="primary"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
          <p class="total">{{ total > 0 ? total : '' }}</p>
        </div>

        <div class="action-buttons">
          <button mat-stroked-button
                  class="syn-dropdown-menu"
                  [matMenuTriggerFor]="actionsMenu"
                  [disabled]="actionButtonsDisabled">
              Modifier
              <mat-icon svgIcon="chevron-down"></mat-icon>
          </button>
          <mat-menu #actionsMenu="matMenu"
                    [overlapTrigger]="false">
              <button mat-menu-item
                      (menuOpened)="updateMenuRolesStatus()"
                      [matMenuTriggerFor]="rolesSubmenu">
                  Modifier les rôles
              </button>
          </mat-menu>
          <mat-menu #rolesSubmenu="matMenu">
              <syn-menu-checkbox #rolesSubmenuItem
                                *ngFor="let role of roles"
                                [label]="role.id"
                                (click)="updateSelectedRoles($event, rolesSubmenuItem, role)">
              </syn-menu-checkbox>
          </mat-menu>
        </div>
      </div>

      <mat-form-field fxFlexOffset="2" fxFlex="40" appearance="outline">
        <mat-label>Rechercher</mat-label>
        <input matInput (keyup)="applyFilter($event)" #input>
      </mat-form-field>
    </div>

    <table mat-table
          [dataSource]="dataSource"
          matSort
          fxFlexFill>

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox color="primary"
                          (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(row) : null"
                          [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
          <td mat-cell *matCellDef="let project">
            <syn-avatar *ngIf="project.id === '*'"
                        [matIco]="'star'"
                        [size]="24"></syn-avatar>
            <syn-project-avatar *ngIf="project.id !== '*'"
                                [project]="project"
                                [showId]="true"
                                [size]="24"></syn-project-avatar>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Projet </th>
          <td mat-cell *matCellDef="let project"> {{project.name}} </td>
        </ng-container>

        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Rôles </th>
          <td mat-cell *matCellDef="let project">
            <mat-form-field *ngIf="showRoleField" fxFlexFill appearance="outline">
              <mat-select [formControlName]="project.id" (click)="$event.stopPropagation()" (selectionChange)="updateDataSource(project.id)" [multiple]="multiple">
                <mat-option *ngFor="let role of roles"
                            [value]="role.id">
                    <syn-select-option-role [role]="role"></syn-select-option-role>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 100]" showFirstLastButtons></mat-paginator>
  </form>
</div>
